import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../utils/Constant";
import styles from "../Onboarding.module.scss";

const Login = (props) => {
  const { onNextStep, onPreviousStep, email } = props;

  const { t } = useTranslation();
  const [credentials, setCredentials] = useState({
    email: email,
    password: "",
  });

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h2>{t("onboard.welcome")}</h2>
      </div>

      <form
        onSubmit={(e) => onNextStep(e, credentials.email, credentials.password)}
      >
        <div className={styles.inputContainer}>
          <label htmlFor="email">{t("sign_in.email")}</label>
          <div id="email" name="email" className={styles.emailText}>
            <span>{credentials.email} </span>
            <span className={styles.changeEmailLink}>
              <Link to="" onClick={onPreviousStep}>
                {t("sign_in.change_email")}
              </Link>
            </span>
          </div>
          <label htmlFor="password">{t("sign_in.password")}</label>
          <input
            value={credentials.password}
            onChange={(e) => {
              const password = e.target.value;
              setCredentials((cred) => ({
                ...cred,
                password,
              }));
            }}
            type="password"
            autoComplete="current-password"
            id="password"
            name="password"
            placeholder={t("sign_in.password")}
            required
            autoFocus
          />
        </div>
        <div className={styles.actionContainer}>
          <input type="submit" value={t("sign_in.continue")} />
          <Link to={ROUTES.RESET_PASSWORD}>{t("sign_in.forgot_password")}</Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
